import { useContainer } from "@pharaday/utils";

import { OnboardingProvider } from "../core/application/onboarding.provider";

const useOnboardingApi = () => {
  const container = useContainer();

  return {
    api: {
      onboarding: container.get<OnboardingProvider>(OnboardingProvider),
    },
  };
};

export { useOnboardingApi };
